export const multiply = <T>(array: T[], length: number) =>
    Array.from({ length }, (_, idx) => array[idx % array.length]);

export const withId = <T>(array: T[]) => {
    let id = 0;

    return array.map((item) => ({ id: String(++id), ...item }));
};
